import React, { Component } from "react";
import { Button, Form, Icon, Table, Grid } from "tabler-react";
import Select from "react-select";
import { AsyncPaginate } from "react-select-async-paginate";
import ModalLay from "../../../components/ModalLay/ModalLay";
import { PersonasForm } from "../../../Catalogos";
import { Crud_Catalogos } from "../../../herramientas/Crud_Catalogos";
import { NotificationManager } from "react-notifications";

var currentUser = JSON.parse(sessionStorage.getItem("currentUser"));

class Reporte extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTap: 0,
      id: 0,
      persona: { value: 0, label: "Seleccione una persona", data: null },
      username: "",
      password: "",
      Cpassword: "",
      msmPAsss: "",
      estatus: 0,
      accion: this.props.accion,
      newPassword: false,
      crudbutonEnable: true,
      idPlataforma: { value: 61, label: "Default", data: { id: 61 } },
      hiddenModal: false,
      idTurnoLaboral: { value: null, label: "Seleccione Turno Laboral", data: null },
      turnosLaborales: [],
    };
    this.usuarioObject = [];
    this.plataformas = [];
  }

  // ========== MÉTODO PARA CARGAR PERSONAS PAGINADAS ==========
  loadPersonasOptions = async (search, loadedOptions, { page }) => {
    try {
      const response = await Crud_Catalogos(
        `personas/paginado?termino=${encodeURIComponent(search)}&pagina=${page}`,
        "tracking",
        "get",
        "",
        [],
        "",
        "personas",
        null,
        []
      );

      const options = response.content.map((p) => ({
        value: p.id,
        label: `${p.nombre} ${p.aPaterno} ${p.aMaterno}`,
        data: p,
      }));

      return {
        options: options,
        hasMore: !response.last, // Si no es la última página, hay más
        additional: {
          page: page + 1, // Incrementar para la siguiente carga
        },
      };
    } catch (error) {
      console.error("Error cargando personas:", error);
      return {
        options: [],
        hasMore: false,
      };
    }
  };

  isEnable = (Accion) => {
    let borrar = "usuarios_borrar";
    let actualizar = "usuarios_editar";
    let agregar = "usuarios_agregar";
    let actualizarPersona = "personas_editar";
    let agregarPersona = "personas_agregar";
    
    var privilegios = this.props.stor.privilegios_object;
    var perfil = JSON.parse(sessionStorage.getItem("perfil"));
    
    for (let i = 0; i < privilegios.length; i++) {
      if (Accion === "actualizarPersona") {
        if (privilegios[i].clave == actualizarPersona) {
          if (perfil.privilegios.filter((word) => word.idPrivilegio == privilegios[i].id).length > 0) {
            return true;
          }
        }
      }
      if (Accion === "agregarPersona") {
        if (privilegios[i].clave == agregarPersona) {
          if (perfil.privilegios.filter((word) => word.idPrivilegio == privilegios[i].id).length > 0) {
            return true;
          }
        }
      }
      if (Accion === "borrar") {
        if (privilegios[i].clave == borrar) {
          if (perfil.privilegios.filter((word) => word.idPrivilegio == privilegios[i].id).length > 0) {
            return true;
          }
        }
      }
      if (Accion === "actualizar") {
        if (privilegios[i].clave == actualizar) {
          if (perfil.privilegios.filter((word) => word.idPrivilegio == privilegios[i].id).length > 0) {
            return true;
          }
        }
      }
      if (Accion === "agregar") {
        if (privilegios[i].clave == agregar) {
          if (perfil.privilegios.filter((word) => word.idPrivilegio == privilegios[i].id).length > 0) {
            return true;
          }
        }
      }
    }
    return false;
  };

  componentDidMount = () => {
    this.plataformas.push({ value: 61, label: "Default", data: { id: 61 } });
    currentUser.map((elemento, index) => {
      this.plataformas.push({
        value: elemento.plataforma.id,
        label: elemento.plataforma.nombre,
        data: elemento.plataforma,
      });
    });

    if (this.state.accion !== "nuevo") {
      let p = this.props.elementos.persona;
      this.setState({
        persona: {
          value: p.id,
          label: p["nombre"] + " " + p["aPaterno"] + " " + p["aMaterno"],
          data: p,
        },
      });
      this.setState({ id: this.props.elementos.id });
      this.setState({ username: this.props.elementos.username });
      this.setState({ password: this.props.elementos.password });
      this.setState({ estatus: this.props.elementos.estatus });
      this.usuarioObject = this.props.elementos;
    } else {
      // Ya no necesitas cargar todas las personas aquí
      this.usuarioObject = {
        username: "",
        password: "",
        estatus: 0,
        persona: {},
        idTurnoLaboral: null,
      };
    }

    this.getfuntion("get", [], "", "turnosLaborales", "turnosLaborales");
  };

  changePlataformas = (event) => {
    this.setState({ idPlataforma: event });
  };

  selectedTab = (index) => {
    this.setState({ currentTap: index });
  };

  changePersona = (event) => {
    this.setState({ persona: event });
    this.usuarioObject.persona = event.data;
  };

  changeTurnoLaboral = (event) => {
    this.setState({ idTurnoLaboral: event });
    this.usuarioObject.idTurnoLaboral = event.value;
  };

  changeUsername = (event) => {
    this.usuarioObject.username = event.target.value;
    this.setState({ username: event.target.value });
  };

  changePassword = (event) => {
    this.usuarioObject.password = event.target.value;
    this.setState({ password: event.target.value });
  };

  changeCpassword = (event) => {
    this.setState({ Cpassword: event.target.value });
  };

  newPassword = (event) => {
    this.setState({ newPassword: !this.state.newPassword });
    if (this.state.newPassword) {
      this.setState({ password: this.props.elementos.password });
    } else {
      this.setState({ password: "" });
      this.setState({ Cpassword: "" });
    }
  };

  changeEstatus = (event) => {
    this.state.estatus === 0
      ? this.setState({ estatus: 1 })
      : this.setState({ estatus: 0 });
    this.state.estatus === 0
      ? (this.usuarioObject.estatus = 1)
      : (this.usuarioObject.estatus = 0);
  };

  guardarUsuario = () => {
    if (this.state.accion === "modificar") this.crud_put();
    else this.crud_post();
    this.props.cerrarModal();
  };

  delete() {
    this.props.getfuntion("delete", "", this.state.id);
    this.setState({ crudbutonEnable: false });
  }

  crud_put() {
    this.props.getfuntion("put", this.usuarioObject);
    this.setState({ crudbutonEnable: false });
  }

  crud_post() {
    this.props.getfuntion("post", this.usuarioObject);
    this.setState({ crudbutonEnable: false });
  }

  crud_putPassword() {
    this.props.getfuntion(
      "put",
      this.usuarioObject,
      "",
      this.usuarioObject,
      "usuarios/password"
    );
  }

  hiddenmodal = () => {
    this.setState({ hiddenModal: !this.state.hiddenModal });
  };

  getfuntion = (
    metodo = "get",
    obj = [],
    id = "",
    catalogo = "personas/plataforma/" + this.state.idPlataforma.value,
    stateVar = "personas",
    hiddenModl = this.hiddenmodal()
  ) => {
    return Crud_Catalogos(
      metodo !== "post" && catalogo.includes("personas") ? "personas" : catalogo,
      "tracking",
      metodo,
      id,
      obj,
      "",
      stateVar,
      hiddenModl,
      []
    )
      .then((returnVal) => {
        switch (metodo) {
          case "get":
            if (stateVar === "turnosLaborales") {
              let turnosLaboralesTemp = [];
              returnVal.map((t) => {
                if (t.id === this.props.elementos.idTurnoLaboral) {
                  this.setState({
                    idTurnoLaboral: {
                      value: t.id,
                      label: t.nombre,
                      data: t,
                    },
                  });
                }
                turnosLaboralesTemp.push({
                  value: t.id,
                  label: t.nombre,
                  data: t,
                });
              });
              this.setState({
                turnosLaborales: turnosLaboralesTemp,
              });
            }
            break;
          case "post":
            {
              if (stateVar === "personas") {
                if (returnVal.id) {
                  // Actualizar la persona seleccionada después de crear
                  this.usuarioObject.persona = returnVal;
                  this.setState({
                    persona: {
                      value: returnVal.id,
                      label:
                        returnVal["nombre"] +
                        " " +
                        returnVal["aPaterno"] +
                        " " +
                        returnVal["aMaterno"],
                      data: returnVal,
                    },
                  });
                }
              }
            }
            break;
          case "put":
            {
              if (stateVar === "personas") {
                if (returnVal.id) {
                  NotificationManager.info(
                    "Se han agregado las modificaciones de ( " +
                      returnVal.nombre +
                      " ), al catálogo general",
                    "Modificación"
                  );
                  this.setState({
                    persona: {
                      value: returnVal.id,
                      label:
                        returnVal["nombre"] +
                        " " +
                        returnVal["aPaterno"] +
                        " " +
                        returnVal["aMaterno"],
                      data: returnVal,
                    },
                  });
                }
              }
            }
            break;
          default:
            break;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  render() {
    return (
      <div>
        <Grid.Row>
          <Grid.Col md={12} xl={12}>
            <Grid.Row>
              <Grid.Col md={4} lg={4}>
                <Form.Group label="De la plataforma se toma la plantilla para validación de correo">
                  <Select
                    value={this.state.idPlataforma}
                    onChange={this.changePlataformas}
                    options={this.plataformas}
                  />
                </Form.Group>
              </Grid.Col>

              <Grid.Col>
                <Form.Group label="Persona">
                  {/* ========== AQUÍ ESTÁ EL CAMBIO PRINCIPAL ========== */}
                  <AsyncPaginate
                    value={this.state.persona}
                    loadOptions={this.loadPersonasOptions}
                    onChange={this.changePersona}
                    additional={{
                      page: 0, // Página inicial
                    }}
                    debounceTimeout={300}
                    placeholder="Buscar persona..."
                    noOptionsMessage={() => "No se encontraron personas"}
                    loadingMessage={() => "Cargando..."}
                    cacheOptions
                  />
                </Form.Group>
              </Grid.Col>

              {this.state.idPlataforma.value > 0 &&
              (this.isEnable("actualizarPersona") ||
                this.isEnable("agregarPersona")) ? (
                <Grid.Col md={2} lg={2}>
                  {this.isEnable("agregarPersona") ? (
                    <span className="float-right">
                      <ModalLay
                        tamanio="85%"
                        title={"Nuevo"}
                        name={
                          <span
                            className="fa fa-plus ml-2"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={
                              "Nueva persona(Antes de crear valida que no exista)"
                            }
                          ></span>
                        }
                        formulario={PersonasForm}
                        datosForm={{
                          accion: "nuevo",
                          plataforma: this.state.idPlataforma.data,
                          elementos: this.state.persona.data,
                          getfuntion: this.getfuntion,
                          stor: this.props.stor,
                        }}
                      />
                    </span>
                  ) : null}
                  {this.isEnable("actualizarPersona") ? (
                    <span className="float-right">
                      {this.state.persona.value > 0 ? (
                        <ModalLay
                          tamanio="85%"
                          title="Modificar"
                          name={
                            <span
                              className="fa fa-edit"
                              data-toggle="tooltip"
                              data-placement="top"
                              title={
                                "Modificar (" + this.state.persona.label + ")"
                              }
                            ></span>
                          }
                          formulario={PersonasForm}
                          datosForm={{
                            accion: "modificar",
                            plataforma: this.state.idPlataforma.data,
                            elementos: this.state.persona.data,
                            getfuntion: this.getfuntion,
                            stor: this.props.stor,
                          }}
                        />
                      ) : null}
                    </span>
                  ) : null}
                </Grid.Col>
              ) : null}
            </Grid.Row>

            <Grid.Col md={4} lg={4}>
              <Form.Group label="Turno Laboral">
                <Select
                  value={this.state.idTurnoLaboral}
                  onChange={this.changeTurnoLaboral}
                  options={this.state.turnosLaborales}
                />
              </Form.Group>
            </Grid.Col>

            <Grid.Row>
              <Grid.Col
                md={this.state.accion === "modificar" ? 3 : 4}
                lg={this.state.accion === "modificar" ? 3 : 4}
              >
                <Form.Group label="username">
                  <Form.Input
                    name="username"
                    type="text"
                    value={this.state.username}
                    onChange={this.changeUsername}
                  />
                </Form.Group>
              </Grid.Col>

              <Grid.Col
                md={this.state.accion === "modificar" ? 3 : 4}
                lg={this.state.accion === "modificar" ? 3 : 4}
              >
                <Form.Group label="password">
                  <Form.Input
                    name="passwrod"
                    type="password"
                    disabled={
                      this.state.accion !== "nuevo" && !this.state.newPassword
                    }
                    value={this.state.password}
                    onChange={this.changePassword}
                  />
                </Form.Group>
              </Grid.Col>

              {this.state.newPassword ? (
                <Grid.Col
                  md={this.state.accion === "modificar" ? 3 : 4}
                  lg={this.state.accion === "modificar" ? 3 : 4}
                >
                  <Form.Group label="confirmar password">
                    <Form.Input
                      name="passwrod"
                      type="password"
                      disabled={
                        this.state.accion !== "nuevo" && !this.state.newPassword
                      }
                      value={this.state.Cpassword}
                      onChange={this.changeCpassword}
                    />
                  </Form.Group>
                </Grid.Col>
              ) : null}

              {this.state.accion === "modificar" ? (
                <Table.Col>
                  <Form.Group>
                    <Form.Switch
                      name="estatus"
                      label="Reestablecer contraseña"
                      value={this.state.newPassword}
                      checked={this.state.newPassword}
                      onChange={this.newPassword}
                    />
                  </Form.Group>
                  {this.state.newPassword ? (
                    <Button
                      target="_blank"
                      size="sm"
                      RootComponent="a"
                      color="primary"
                      disabled={
                        this.state.Cpassword === this.state.password &&
                        this.state.password.length > 0 &&
                        this.state.Cpassword.length > 0
                          ? false
                          : true
                      }
                      onClick={() => this.crud_putPassword()}
                    >
                      <span className="badge">
                        <Icon link={true} name="refresh-ccw" />
                        Actualizar
                      </span>
                    </Button>
                  ) : null}
                </Table.Col>
              ) : null}
            </Grid.Row>
          </Grid.Col>

          <Form.Group>
            <Form.Switch
              name="estatus"
              label="Activo"
              value={this.state.estatus}
              checked={this.state.estatus}
              onChange={this.changeEstatus}
            />
          </Form.Group>
        </Grid.Row>

        <div className="float-right">
          {this.isEnable("actualizar" || this.isEnable("agregar")) ? (
            <span className="badge">
              <Button
                target="_blank"
                size="sm"
                RootComponent="a"
                color="primary"
                disabled={
                  (this.state.persona.value > 0
                    ? this.state.username.length > 0
                      ? this.state.password.length > 0
                        ? !this.state.newPassword
                          ? false
                          : true
                        : true
                      : true
                    : true) || !this.state.crudbutonEnable
                }
                onClick={this.guardarUsuario}
              >
                <span className="badge">
                  <Icon link={true} name="save" />
                  Guardar
                </span>
              </Button>
            </span>
          ) : null}

          {this.state.accion === "modificar" && this.isEnable("borrar") ? (
            <span className="badge">
              <Button
                target="_blank"
                size="sm"
                RootComponent="a"
                color="primary"
                onClick={() => this.delete()}
                disabled={!this.state.crudbutonEnable}
              >
                <span className="badge">
                  <Icon link={true} name="trash" />
                  Borrar
                </span>
              </Button>
            </span>
          ) : null}
        </div>
      </div>
    );
  }
}

export default Reporte;